import { render, staticRenderFns } from "./QuestBottomControls.vue?vue&type=template&id=0243dd92&scoped=true"
import script from "./QuestBottomControls.vue?vue&type=script&lang=js"
export * from "./QuestBottomControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243dd92",
  null
  
)

export default component.exports